var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-wrapper"},[_c('apexchart',{attrs:{"type":"line","height":"100%","options":_vm.chartOptions,"series":_vm.chartSeries}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }